var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex", class: _vm.classes },
    [
      _vm._l(_vm.items, function (item, index) {
        return _vm.items.length !== 0
          ? _c(
              item.name,
              _vm._g(
                _vm._b(
                  { key: index, tag: "component" },
                  "component",
                  item.attrs || {},
                  false
                ),
                item.listeners || {}
              )
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.items.length === 0 ? _vm._t("default") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }